// extracted by mini-css-extract-plugin
export var feature = "feature-module--feature--1rDVn";
export var screenshot = "feature-module--screenshot--Yt11O";
export var description = "feature-module--description--8dXFN";
export var descriptionRight = "feature-module--descriptionRight--FG6Qx";
export var featureTitle = "feature-module--featureTitle--6swSJ";
export var excerpt = "feature-module--excerpt--6mSez";